import { Outlet, useOutletContext } from 'react-router';

import { FeatureFlagGuard } from '@/shared/ui/guards';

/**
 * Guards the folders route tree behind `hide_asset_approvals`, forwarding the
 * outlet context.
 *
 * The forwarding is the load-bearing part: an `<Outlet />` with no `context`
 * publishes `undefined`, which shadows the context `ProjectDetail` provides one
 * level up. Every page under this route destructures that context, so dropping
 * it takes the whole section down.
 *
 * Lives in its own file, like `PaddedOutlet`, so `AppRoutes.tsx` stays a pure
 * exporter of the `router` factory.
 */
export const ApprovalsGuardedOutlet = () => {
  const context = useOutletContext();

  return (
    <FeatureFlagGuard flag="hide_asset_approvals" invert>
      <Outlet context={context} />
    </FeatureFlagGuard>
  );
};
